import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProfessional = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16 2.66669L5.33333 6.66669V14.7867C5.33333 21.52 9.87999 27.8 16 29.3334C22.12 27.8 26.6667 21.52 26.6667 14.7867V6.66669L16 2.66669ZM24 14.7867C24 20.12 20.6 25.0534 16 26.56C11.4 25.0534 7.99999 20.1334 7.99999 14.7867V8.52002L16 5.52002L24 8.52002V14.7867Z",
		fill: "currentColor"
	})
});
export default SvgProfessional;
